import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';

import { createResignation, getResignation } from '@api/resignation';

import {
  ResignationActions,
  createResignationFailed,
  createResignationSuccess,
  getResignationFailed,
  getResignationSuccess,
} from '@actions/HRM/resignation/resignation-actions';
import {
  CREATE_RESIGNATION,
  GET_RESIGNATION,
} from '@actions/HRM/resignation/types';

import { StoreType } from '@reducers/types';

import { isRequestCancelled } from '@helpers/routing';

export const resignationsMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: ResignationActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case CREATE_RESIGNATION.CREATE_RESIGNATION_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await createResignation(payload);

            dispatch(createResignationSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(createResignationFailed());
            }
          }
          break;
        }

        case GET_RESIGNATION.GET_RESIGNATION_REQUEST: {
          const { payload } = action as any;

          try {
            const { data } = await getResignation(payload?.data);

            dispatch(getResignationSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getResignationFailed());
            }
          }
          break;
        }
      }
      return nextAction;
    };
  };
};
